import { api } from './networkService';

class StreetService {
    static async fetchStreets(page, filters) {
        try {
            const response = await api.get(`api/user/street`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch street error:', error);
            throw error;
        }
    }

    static async fetchAll() {
        try {
            const response = await api.get(`api/user/street`);
            return response.data;
        } catch (error) {
            console.error('Fetch street error:', error);
            throw error;
        }
    }

    static async fetchAllByCity(cityId) {
        try {
            const response = await api.get(`api/user/street`, {
                params: { cityId }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch street error:', error);
            throw error;
        }
    }

    static async addStreet(street) {
        try {
            const response = await api.post(`api/user/street`, street);
            return response;
        } catch (error) {
            console.error('Add street error:', error);
            throw error;
        }
    }

    static async updateStreet(street) {
        try {
            const { id, ...info } = street;
            const response = await api.put(`api/user/street/${id}`, info);
            return response;
        } catch (error) {
            console.error('Update street error:', error);
            throw error;
        }
    }

    static async deleteStreet(id) {
        try {
            const response = await api.delete(`api/user/street/${id}`);
            return response;
        } catch (error) {
            console.error('Delete street error:', error);
            throw error;
        }
    }
}

export default StreetService;
